import { Theme } from '@mui/material/styles';
import { useBoolean } from 'usehooks-ts';

import { UserRefresher } from '@/components/AppRouter/UserRefresher';
import { ProgressDots } from '@/components/DataDisplay/Indicator/ProgressDots';
import { Screen } from '@/components/Layout/Screen';

import { useAppSelector } from '@/hooks/redux';
import { useTranslate } from '@/hooks/useTranslate';

import {
  AddressBody,
  CaymanCountryICBCheckingPage,
  ICBCheckingPage,
} from '@/pages/onboarding/address-information';

import { selectLoggedInUser } from '@/redux/auth/selectors';

import { Tenant } from '@/types/common';

import { PROGRESS_STEPS } from '@/utils/progressSteps';
import { isCaymanTenant } from '@/utils/tenant';
import { isCaymanUser, skipICBCheckingPage } from '@/utils/user';

function renderICBCheckingScreen(tenant?: Tenant) {
  if (isCaymanTenant(tenant)) {
    return <CaymanCountryICBCheckingPage />;
  }
  return <ICBCheckingPage />;
}

export default function AddressScreen() {
  const user = useAppSelector(selectLoggedInUser);
  const { value: isFinished, setTrue: setFinished } = useBoolean(false);
  const { t } = useTranslate();

  if (isFinished) {
    return skipICBCheckingPage(user) ? (
      <UserRefresher noLoader />
    ) : (
      renderICBCheckingScreen(user?.tenant)
    );
  }

  return (
    <Screen
      header={{
        leftSlot: null,
        centerSlot: (
          <ProgressDots
            {...PROGRESS_STEPS.addressStep}
            text={
              !isCaymanUser(user)
                ? t('createNewAccount.addressPage.wellDone')
                : ''
            }
          />
        ),
        bgColor: theme => theme.palette.background.paper,
      }}
      center
      bgColor={(theme: Theme) => theme.palette.background.paper}
    >
      <AddressBody
        hasLogo={true}
        tenant={user?.tenant}
        onFinished={setFinished}
      />
    </Screen>
  );
}
